<button class="btn btn-sm btn-transparent me-2 show-hide-toggle" data-cy="showHideButton" (click)="clicked($event)"><i-bs name="chevron-down" [ngClass]='{hidden: showHideState === "hide", "text-white": color === "white"}'></i-bs></button>
